import { CgBreakpoints } from "../../components/common/cgBreakpoints";
import { debounce } from "underscore";


export class NavigationSite {
    delay = 200;

    constructor(navigation) {
        this.nav = $(navigation);
        if (!this.nav.length) {
            return;
        }

        this.init();
    }

    init() {
        this.set();
        this.bindEvents();
    }

    set() {
        this.update();
        this.nav.children('ul').children('li')
            .has('.lnk[href~="' + window.location.pathname + '"]').addClass('active');
    }

    bindEvents() {
        this.nav.find('ul').children('li')
            .mouseenter(() => this.activate())
            .mouseleave(() => this.deactivate())
            .resize(debounce(() => {
                this.update();
            }, 200));
    }

    // auxiliary
    activate() {
        const item = $(this);

        if (!item.is('.active')) {
            item.addClass('active');
        }
    }

    deactivate() {
        const item = $(this);

        if (item.is('.active')) {
            window.setTimeout(() => {
                item.removeClass('active');
            }, this.delay);
        }
    }

    update() {
        const items = this.nav.children('ul').children('li');
        const activeItem = items.has('.active');

        if (this.isMobile()) {
            if (activeItem.length) {
                items.not(activeItem).addClass('hidden');
            }
        } else {
            items.removeClass('hidden');
        }
    }

    isMobile() {
        const cgBreakpoints = new CgBreakpoints();

        return cgBreakpoints.isMobile();
    }
}
